// ----------------------------------------------------------------------
// <copyright file="Izenda.Security.AdditiveField.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Security Additive Field Component
 */
!(function () {
  var React = require('react');
  var observer = require('mobx-react').observer;

  var Panel = require('share/components/controls/Izenda.Panel');
  var Button = require('share/components/controls/Izenda.Button');
  var EventsUtils = require('EventUtils');

  var SecurityAdditiveField = React.createClass({

    propTypes: {
      store: React.PropTypes.object.isRequired
    },
   
    renderVisibleField: function (bundle) {
      var notifyChange = EventsUtils.notifyChange;
      var model = this.props.store.model;

      return (
          <div className="form-group">
            <label className="col-md-7 col-xs-6 control-label field-name">
              <span>{bundle.LABEL.VISIBLE_FIELD_LABEL}</span>
              <i className="icon-info-circled"
                 title={bundle.TOOLTIP.VISIBLE_FIELD_TOOLTIP}/>
            </label>
            <div className="col-md-5 col-xs-6">
              <input type="checkbox"
                     checked={model.additiveFieldAutoVisibleValue}
                     onChange={notifyChange(model.updateFieldVisible.bind(model), EventsUtils.CHECKBOX)}/>
            </div>
          </div>
      )
    },

    renderFilterableField: function (bundle) {
      var notifyChange = EventsUtils.notifyChange;
      var model = this.props.store.model;

      return (
          <div className="form-group">
            <label className="col-md-7 col-xs-6 control-label field-name">
              <span>{bundle.LABEL.FILTERABLE_FIELD_LABEL}</span>
              <i className="icon-info-circled"
                 title={bundle.TOOLTIP.FILTERABLE_FIELD_TOOLTIP}/>
            </label>
            <div className="col-md-5 col-xs-6">
              <input type="checkbox"
                     checked={model.additiveFieldAutoFilterableValue}
                     onChange={notifyChange(model.updateFieldsFilterable.bind(model), EventsUtils.CHECKBOX)}/>
            </div>
          </div>
      )
    },

    render: function () {
      var store = this.props.store;
      var bundle = store.getBundle();

      return (
          <div className="form-horizontal">
            {this.renderVisibleField(bundle)}
            {this.renderFilterableField(bundle)}
          </div>
      )
    },
  });

  module.exports = observer(SecurityAdditiveField);
}());


// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/AdvancedSetting/Izenda.SecurityAdditiveField.jsx